<template>
  <div class="ag-page_assets position-relative">
    <ag-loading v-if="loading" />
    <div class="ag-content ag-card" v-else>
      <div
        class="
          ag-card_header
          d-flex
          align-items-center
          p-3
          justify-content-between
        "
      >
        <div class="ag-card_breadcrumb">
          <div class="d-flex align-items-center mr-2">
            <i class="ag-icon ag-icon_assets mr-2"></i>
            {{ selectedComp.WindowsComputerName }}
          </div>
        </div>
      </div>
      <div class="ag-card_body">
        <div class="row ag-computer p-4">
          <div class="col-md-6">
            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.WindowsComputerName"
                    :options="{ position: 'middle', first: 8, last: 8 }"
                  ></ag-truncate>
                </h5>
                <h6>Endpoint Host Name</h6>
              </div>
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.MachineDomainWorkgroup"
                    :options="{ position: 'middle', first: 13, last: 13 }"
                  ></ag-truncate>
                </h5>
                <h6>{{ $t("domain") }}</h6>
              </div>
            </div>

            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>
                  {{
                    selectedComp.companySiteGroupInfo
                      ? selectedComp.companySiteGroupInfo.siteName
                      : ""
                  }}
                </h5>
                <h6>{{ $t("sitename") }}</h6>
              </div>
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.companySiteGroupInfo.groupName"
                    v-if="selectedComp.companySiteGroupInfo"
                    :options="{ position: 'middle', first: 13, last: 13 }"
                  ></ag-truncate>
                </h5>
                <h6>{{ $t("groupname") }}</h6>
              </div>
            </div>
            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>{{ selectedComp.PolicyFileVersion }}</h5>
                <h6>Policy Version</h6>
              </div>
              <div class="w-50">
                <h5>
                  {{ selectedComp.eventCount }}
                </h5>
                <h6>Event Count</h6>
              </div>
            </div>

            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>{{ selectedComp.LastIPv4 }}</h5>
                <h6>Last IP v4</h6>
              </div>
              <div class="w-50">
                <h5>
                  <ag-truncate
                    :text="selectedComp.LastIPv6"
                    :options="{ position: 'middle', first: 15, last: 15 }"
                  ></ag-truncate>
                </h5>
                <h6>Last IP v6</h6>
              </div>
            </div>

            <div class="d-flex justify-content-between mb-4">
              <div class="w-50">
                <h5>{{ selectedComp.AgentVersion }}</h5>
                <h6>Agent Version</h6>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row graphs">
              <div class="col-md-6">
                <ag-charts
                  style="height: 350px"
                  :options="maliciousHashes"
                ></ag-charts>
              </div>
              <div class="col-md-6">
                <ag-charts
                  style="height: 350px"
                  :options="severityDistribution"
                ></ag-charts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgCharts from "@/components/ag-charts";
import { useStore } from "@/store";
import api from "@/api/index";
import { Roles } from "@/helpers/enums/Roles";
import AgLoading from "@/components/ag-loading/index.vue";
import AgTruncate from "@/components/ag-truncate/index.vue";

const store = useStore();
export default {
  name: "ag-computer",
  data() {
    return {
      loading: true,
      company: "",
      site: "",
      group: "",
      Roles: Roles,
      selectedComp: {},
      maliciousHashes: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "11",
          },
        },
        series: [
          {
            name: "Numbers of found hashes",
            type: "pie",
            radius: ["54%", "60%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "center",
              backgroundColor: "#f8f8f8",
              padding: 10,
            },
            data: [],
          },
        ],
        color: ["#D15656", "#F2AE11", "#61A667"],
      },
      severityDistribution: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "11",
          },
        },
        series: [
          {
            name: "Severity Distribution",
            type: "pie",
            radius: ["54%", "60%"],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true,
              position: "center",
              backgroundColor: "#f8f8f8",
              padding: 10,
            },
            data: [],
          },
        ],
        color: ["#D15656", "#F2AE11", "#61A667"],
      },
    };
  },
  components: { AgCharts, AgLoading, AgTruncate },
  async mounted() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const guid = this.$route.params.computerGuid;
      const res = await api.computers.getComputerDetail(guid);
      const computerDetail = res.data.entityData;
      this.selectedComp = computerDetail;
      computerDetail.severityReport.forEach((item) => {
        this.severityDistribution.series[0].data.push({
          name: `Severity ${item.key}`,
          value: item.value,
        });
      });
      computerDetail.hashReport.forEach((item) => {
        this.maliciousHashes.series[0].data.push({
          name: item.key,
          value: item.value,
        });
      });

      if (
        !this.maliciousHashes.series[0].data.find((i) => i.name == "Malicious")
      ) {
        this.maliciousHashes.series[0].data.push({
          name: "Malicious",
          value: 0,
          itemStyle: { color: "#d15656" },
        });
      }

      if (
        !this.maliciousHashes.series[0].data.find((i) => i.name == "Suspicious")
      ) {
        this.maliciousHashes.series[0].data.push({
          name: "Suspicious",
          value: 0,
          itemStyle: { color: "#f2ae11" },
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-computer {
  h3 {
    color: #5e5e5e;
  }
  h6 {
    color: #9f9f9f;
  }
}
</style>
